export default ({ iosRatio, androidRatio } = {}) => {
	return {
		data: {
			labels: ['iOS', 'Android'],
			datasets: [
				{
					borderWidth: 0,
					backgroundColor: ['#df1962', '#ffa21a'],
					data: [iosRatio, androidRatio],
				},
			],
		},
		options: {
			plugins: {
				datalabels: {
					font: {
						size: '12',
					},
					formatter: (value) => `${value}%`,
				},
			},
			responsive: true,
			maintainAspectRatio: false,
			legend: {
				display: false,
			},
		},
		customLegend: [
			{
				color: '#df1962',
				text: 'iOS',
			},
			{
				color: '#ffa21a',
				text: 'Android',
			},
		],
		type: 'pie',
		hasData: Boolean(iosRatio || androidRatio),
	};
};
